import Axios from "axios";
import { get } from "lodash-es";

const __resolver = new WeakMap();
const axios = Axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  timeout: 0
});
axios.interceptors.response.use(
  (response) => {
    const { data: res } = response;
    if (res.result === "0") {
      return res;
    } else {
      return catchBadRes(response);
    }
  },
  (thrown) => catchBadRes(thrown)
);
function catchBadRes(thrown) {
  // 因为取消导致的错误 - 不显示
  // if (!Axios.isCancel(thrown)) {
  //   const msg = get(thrown, 'data.data.message') || get(thrown, 'data.message') || get(thrown, 'message') || '请求失败';
  //   ElMessage.error(msg);
  // }
  throw thrown;
}
export default {
  axios,
  sleep: (delay = 0) => new Promise((resolve) => setTimeout(resolve, delay)),
  /**
   * @description 同 {Promise.withResolvers}
   * @returns {{ promise: Promise, resolve: (value: any) => void, reject:(reason?: any) => void }}
   */
  withResolvers: () => {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    const resolver = { promise, resolve, reject };
    __resolver.set(promise, resolver);
    return resolver;
  },
  nextZIndex() {
    let zIndex = 0;
    document.querySelectorAll("*").forEach((d) => {
      zIndex = Math.max(~~getComputedStyle(d).zIndex, zIndex);
    });
    return zIndex;
  },
  STATUS: {
    PENDING: 'pending',
    UPLOADING: 'uploading',
    SUCCESS: 'success',
    ERROR: 'error',
    PAUSE: 'pause',
    MERGE: 'merge',
    TEST: 'test'
  },
  StatusMap: {
    'pending': '等待中',
    'uploading': '上传中',
    'success': '上传成功',
    'error': '上传失败',
    'pause': '暂停',
    'merge': '合并中',
    'test': '准备中'
  },
  message: (thrown) => get(thrown, 'data.data.message') || get(thrown, 'data.message') || get(thrown, 'message') || thrown
};
